import { BASE_URL } from '../BASE_URL';

export const getEvent = async (id) => {
  const response = await fetch(BASE_URL + `events/${id}`, {
    method: 'GET',
  });
  const data = await response.json();
  return data;
};
